import React, { useEffect, useState } from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import css from './GiveawayWinnersPage.module.css';

// Import images
import image1 from './Joshwinner1.jpg';
import imageCharles from './CharlesWinner.jpg'

const GiveawayWinnersPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const [winners, setWinners] = useState([]);

  useEffect(() => {
    // Fetch blogs from API and set them to state
    // This is a placeholder and should be replaced with actual API call
    setWinners([
      {
        name: 'Josh',
        image: image1,
        title: 'Congratulations to Josh, Our Giveaway Sweepstakes Winner!',
        excerpt: `We are excited to announce that Josh is the fortunate winner of Lenddit's first Giveaway Sweepstakes! `,
        overlayText: '2023 National Sweepstakes Giveaway',
        yearBadge: '2023 Winner',
      },
      {
        name: 'Charles',
        image: imageCharles,
        title: 'Congratulations to Charles, Our Central Ohio Giveaway Sweepstakes Winner!',
        excerpt: `We're thrilled to share the news that Charles has been selected as the lucky winner of Lenddit's Central Ohio Giveaway Sweepstakes!`,
        overlayText: '2023 Central Ohio Sweepstakes Winner',
        yearBadge: '2023 Central Ohio Winner',
      },
    ]);
  }, []);

  return (
    <StaticPage
      title="Giveaway Winners"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'GiveawayWinnersPage',
        description: 'GiveawayWinnersPage',
        name: 'GiveawayWinnersPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.introSection}>
            <h1>Lenddit's Sweepstake Winners</h1>
            <h2>
              We believe in rewarding our community rather than spending on outside marketing. The
              more followers we can obtain on social media, the more we can give back to our users.
              That's why we've launched our very own Sweepstakes. Get to know the fortunate winners
              who've benefited directly from being a part of our Lenddit family!
            </h2>
          </div>
          <div className={css.GiveawayWinnersPage}>
            {/*<h1 className={css['GiveawayWinnersPage h1']}>Lenddit's Sweepstake Winners</h1>*/}
            <div className={css['grid-container']}>
              {winners.map((winner, index) => (
                <div className={`${css['grid-item']} ${css[`grid-item-${index + 1}`]}`} key={index}>
                  <div className={css['image-container']}>
                    <img src={winner.image} alt={winner.title} />
                    <div className={css['overlay-text']}>{winner.overlayText}</div>
                    <div className={css['year-badge']}>{winner.yearBadge}</div>
                  </div>
                  <h2>{winner.title}</h2>
                  <p>{winner.excerpt}</p>
                </div>
              ))}
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default GiveawayWinnersPage;

